export default __webpack_public_path__ + "static/media/comfort1.4aab6396.jpg";